module.exports = __webpack_public_path__ + "static/sensibill-logo-3bc8c3783b8f4910831c803c65ab7090.jpg";